import React from 'react'
import { AppProvider, AppContext } from 'state/AppProvider'
import { MapProvider, MapContext } from 'state/MapProvider'
import { ScoringProvider, ScoringContext } from 'state/ScoringProvider'

export const GlobalStateProvider = ({children}: React.PropsWithChildren) => {
  return (
    <AppProvider>
      <MapProvider>
        <ScoringProvider>
          {children}
        </ScoringProvider>
      </MapProvider>
    </AppProvider>
  )
}

export const useGlobalState = () => {
  const app = React.useContext(AppContext)
  const map = React.useContext(MapContext)
  const scoring = React.useContext(ScoringContext)
  if (!app || !map || !scoring) {
    throw new Error('Context is undefined')
  }
  const mapbox = map.mapbox
  return { app, map, scoring, mapbox }
}
